































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

@Component
export default class DynamicRows extends Mixins(HasValidation) {
  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public emptyRow!: any;

  @Prop({ required: true })
  public fieldPath!: string;

  public usedRows: any[] = [];
  public dynamicRows = this.value;

  public created() {
    this.usedRows = this.value;
  }

  public get rowsLength() {
    return this.usedRows.length;
  }

  public setDynamicRows(values) {
    this.dynamicRows = values;
    this.$emit("input", values);
  }

  public addNewRow() {
    this.usedRows.push(this.$_.cloneDeep(this.emptyRow));
  }

  public removeRow(index) {
    this.usedRows.splice(index, 1);
  }

  public isRowEmpty(row) {
    return this.$_.isEmpty(
      this.$_.pickBy(row, value => {
        return value !== "" && value !== null;
      })
    );
  }

  public rowHasError(index, row) {
    return this.$_.some(row, (rowValue, rowKey) => {
      return (
        this.$_.get(
          this.validationErrors,
          `${this.fieldPath}.${rowKey}.${index}`,
          []
        ).length > 0
      );
    });
  }

  @Watch("usedRows", { deep: true, immediate: true })
  public onUsedRowsChange() {
    if (!this.$_.some(this.usedRows, usedRow => this.isRowEmpty(usedRow))) {
      this.addNewRow();
      return;
    }

    if (
      this.usedRows.length > 1 &&
      this.isRowEmpty(this.usedRows[this.usedRows.length - 2])
    ) {
      this.usedRows.pop();
    }

    this.setDynamicRows(this.usedRows);
  }
}
